import type { ReactNode } from 'react';
import { STEP_LABELS, type SupplyFormStep } from './supplyFormConstants';

interface SupplySinglePageLayoutProps {
  steps: SupplyFormStep[];
  renderStep: (step: SupplyFormStep) => ReactNode;
}

function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="pb-8 border-b border-gray-200 dark:border-charcoal-700 last:border-0">
      <h3 className="font-display text-lg font-semibold text-gray-900 dark:text-warm-cream mb-4">
        {title}
      </h3>
      {children}
    </section>
  );
}

export function SupplySinglePageLayout({ steps, renderStep }: SupplySinglePageLayoutProps) {
  return (
    <div className="space-y-8">
      {steps.map((step) => (
        <Section key={step} title={STEP_LABELS[step]}>
          {renderStep(step)}
        </Section>
      ))}
    </div>
  );
}
